export const enClientPortalTaskOverviewPagePages = {
    taskOverviewPage: {
        search: 'Search task',
        assignee: 'Assignee',
        currentUserSuffix: ' (Me)',
        noUsers: 'No users found',
        noOrders: 'No orders found',
        noPortfolios: 'No portfolios found',
        team: 'Team',
        noTeams: 'No teams found',
        resetFilters: 'Reset all filters',
        showDone: 'Show completed',
        loading: 'Loading...',
        sort: {
            dueDateAscending: 'Deadline (ascending)',
            dueDateDescending: 'Deadline (descending)',
            titleAscending: 'Task title (A-Z)',
            titleDescending: 'Task title (Z-A)',
        },
        table: {
            title: 'Title',
            team: 'Team',
            deadline: 'Deadline',
            remaining: 'Remaining',
            entries_one: '{{count}} entry',
            entries_other: '{{count}} entries',
            selectedEntries_one: '{{selectedCount}} of {{totalCount}} entry selected',
            selectedEntries_other: '{{selectedCount}} of {{totalCount}} entries selected',
            pageLabel: '{{page}} of {{pageCount}} pages',
            emptyFiltered: 'No entries match your search',
            empty: 'No entries available',
            remainingToday: 'Today',
            remainingDays_one: '{{count}} day',
            remainingDays_other: '{{count}} days',
            remainingOverdueDays_one: '{{count}} day overdue',
            remainingOverdueDays_other: '{{count}} days overdue',
            remainingOverMaxDays_one: 'More than {{count}} day',
            remainingOverMaxDays_other: 'More than {{count}} days',
            actions: {
                edit: 'Edit entry',
                delete: 'Delete entry',
                ariaLabel: 'Row {{rowIndex}} options',
            },
        },
    },
}
